package com.vizio.redwolf.auth.model

import com.vizio.redwolf.utils.ResponseHeaders
import com.vizio.redwolf.utils.model.PayFailureResponse
import kotlin.js.JsExport

@JsExport
sealed class AccountResult<out T : Any> {
    data class Success<out T : Any>(val headers: ResponseHeaders, val data: T) : AccountResult<T>()
    data class Failed(val headers: ResponseHeaders, val response: PayFailureResponse) : AccountResult<Nothing>()
    data class Error(val headers: ResponseHeaders, val exception: Throwable) : AccountResult<Nothing>()
    data class Timeout(val headers: ResponseHeaders, val exception: Throwable) : AccountResult<Nothing>()

    fun <R> fold(
        onSuccess: (Success: Success<T>) -> R,
        onFailed: (Failed: Failed) -> R,
        onError: (Error: Error) -> R,
        onTimeout: (Timeout: Timeout) -> R
    ): R {
        return when (this) {
            is Success -> onSuccess(Success(this.headers, this.data))
            is Failed -> onFailed(Failed(this.headers, this.response))
            is Error -> onError(Error(this.headers, this.exception))
            is Timeout -> onTimeout(Timeout(this.headers, this.exception))
        }
    }
}